import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '@/utils/helpers';
import { AdService } from '@/api/types/services.types';
import * as S from '@/components/Ad/Promotions/PromotionDrawer.styles';
import { getPriceWithDiscount } from '@/components/Ad/Promotions/PromotionDrawer.helpers';
import { getPartialServiceLabel } from '@/views/Wallet/Finish.helpers';
import { BUMPS_PER_DAY } from '@/components/Ad/Promotions/Promotions.constants';

type Props = {
  currentService: AdService;
  isPeriod?: boolean;
  withSale?: boolean;
  walletDiscount: number;
  isWallet: boolean;
};

export function ServiceLabel({
  currentService,
  isPeriod,
  withSale,
  walletDiscount,
  isWallet,
}: Props) {
  const { t } = useTranslation();
  const period = isPeriod
    ? getPartialServiceLabel(
        t,
        currentService.period * BUMPS_PER_DAY,
        'n',
        'pages.ad.service_period_price'
      )
    : getPartialServiceLabel(
        t,
        currentService.period,
        'days',
        'pages.ad.service_price'
      );

  const price = getPriceWithDiscount(
    currentService.price,
    isWallet,
    walletDiscount
  );

  const formattedPrice = formatNumber(price, 2);

  return (
    <S.ServiceLabelText>
      {period}
      {withSale ? (
        <>
          {' '}
          / <S.NewPrice $variant="1">{formattedPrice} AZN</S.NewPrice>
        </>
      ) : (
        ` / ${formattedPrice} AZN`
      )}
    </S.ServiceLabelText>
  );
}
